import { render, staticRenderFns } from "./approveDtl.vue?vue&type=template&id=f24bc892&scoped=true&"
import script from "./approveDtl.vue?vue&type=script&lang=js&"
export * from "./approveDtl.vue?vue&type=script&lang=js&"
import style0 from "./approveDtl.vue?vue&type=style&index=0&id=f24bc892&prod&lang=scss&scoped=true&"
import style1 from "./approveDtl.vue?vue&type=style&index=1&id=f24bc892&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24bc892",
  null
  
)

export default component.exports